// resources/js/src/components/community/comments/CommentInput.tsx
import React from "react";
import { Icon } from "@iconify/react";
import { useAuthStore } from "../../../../auth/auth.store";

type Props = {
  text: string;
  setText: React.Dispatch<React.SetStateAction<string>>;
  onSubmit: () => void;
  submitting?: boolean;
  placeholder?: string;
};

const CommentInput: React.FC<Props> = ({
  text,
  setText,
  onSubmit,
  submitting = false,
  placeholder = "Write a comment...",
}) => {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  if (!isAuthenticated) {
    return (
      <div className="flex items-center gap-2 rounded-full px-4 py-2 bg-charcoalGray/20 dark:bg-dark_grey text-sm text-gray-500">
        <a
          href="/login"
          className="font-semibold text-tealGreen dark:text-primary hover:underline"
        >
          Sign in
        </a>
        <span>to write a comment</span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2">
      <input
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder={placeholder}
        disabled={submitting}
        className="flex-1 rounded-full px-4 py-2 bg-charcoalGray/20 dark:bg-dark_grey focus:outline-none disabled:opacity-50"
        onKeyDown={(e) => {
          if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            onSubmit();
          }
        }}
      />

      <button
        onClick={onSubmit}
        disabled={!text.trim() || submitting}
        className="dark:text-primary cursor-pointer text-tealGreen disabled:opacity-40"
        aria-label="Send comment"
      >
        {submitting ? (
          <span className="inline-block h-4 w-4 animate-spin rounded-full border-2 border-current/30 border-t-current" />
        ) : (
          <Icon icon="mdi:send" className="w-5 h-5" />
        )}
      </button>
    </div>
  );
};

export default CommentInput;